<crud-list class="col-12" [data]="table" detailUrl="/enaio-templates/edit-template-field/" restUrl="api/tpl/templatefieldpersistentdata" [allowDelete]=false [allowCreate]=false>
</crud-list>
